import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { BRAND_VALUE_FILTER_TYPE, buildFilterKey } from "@faire/retailer-shared/filters/filterKeys";
import { splitFiltersFromQueryParamString } from "@faire/retailer-shared/filters/splitFiltersFromQueryParams";
import { uniqueAndSorted } from "@faire/retailer-visitor-shared/lib/uniqueAndSorted";
import { isTupleOfLength } from "@faire/web--source/common/typescriptUtils";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import { route as categoryC1BrandValueRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/brand-value/brandValue";
import { route as categoryC2BrandValueRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/brand-value/brandValue";
import { route as categoryC3BrandValueRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/brand-value/brandValue";
import { route as supplierC1BrandValueRoute } from "@faire/web-api--source/routes/suppliers/c1SuppliersUrlId/brand-value/brandValue";
import qs from "query-string";
import { useEffect, useMemo, useRef } from "react";
import { useLocation, useHistory, matchPath } from "react-router-dom";
export var useCategoryPageQueryParams = function() {
    var location = useLocation();
    var history = useHistory();
    var queryParams = useQueryParams(QueryParameters.parse);
    var updateQueryParamsAndStringify = useUpdateQueryParamsAndStringify(queryParams);
    var filters = queryParams.filters;
    var uniqueSortedFilterKeys = useMemo(function() {
        var _ref;
        // This is to support standard query params like `?filters=k1&filters=k2`
        var normalizedFiltersQueryParams = (_ref = filters && isTupleOfLength(filters, 1) ? splitFiltersFromQueryParamString(filters[0]) : filters) !== null && _ref !== void 0 ? _ref : [];
        return uniqueAndSorted(normalizedFiltersQueryParams);
    }, [
        filters
    ]);
    var setFilterKeys = function(updater) {
        var updatedFilterKeys = uniqueAndSorted(updater(uniqueSortedFilterKeys));
        var queryString = updateQueryParamsAndStringify(function(oldParams) {
            return _object_spread_props(_object_spread({}, oldParams), {
                filters: updatedFilterKeys.length === 0 ? undefined : [
                    updatedFilterKeys.join(",")
                ]
            });
        });
        var matchForFilterByBrandValue = matchPath(location.pathname, {
            path: [
                categoryC1BrandValueRoute,
                supplierC1BrandValueRoute,
                categoryC2BrandValueRoute,
                categoryC3BrandValueRoute
            ]
        });
        if (matchForFilterByBrandValue === null || matchForFilterByBrandValue === void 0 ? void 0 : matchForFilterByBrandValue.params.brandValue) {
            var brandValue = matchForFilterByBrandValue.params.brandValue;
            var shouldRemoveBrandValueInURL = !(queryString === null || queryString === void 0 ? void 0 : queryString.includes(buildFilterKey(BRAND_VALUE_FILTER_TYPE, brandValue)));
            if (shouldRemoveBrandValueInURL) {
                history.push({
                    pathname: location.pathname.replace("/brand-value/".concat(brandValue), ""),
                    search: queryString
                });
            }
        } else {
            history.push({
                pathname: location.pathname,
                search: queryString
            });
        }
    };
    var clearFilters = function() {
        setFilterKeys(function() {
            return [];
        });
    };
    var _queryParams_page;
    var oneIndexedPageNumber = (_queryParams_page = queryParams.page) !== null && _queryParams_page !== void 0 ? _queryParams_page : 1;
    var setOneIndexedPageNumber = function(updater) {
        var _queryParams_page;
        var newPageNumber = updater((_queryParams_page = queryParams.page) !== null && _queryParams_page !== void 0 ? _queryParams_page : 1);
        var queryString = updateQueryParamsAndStringify(function(oldParams) {
            return _object_spread_props(_object_spread({}, oldParams), {
                page: newPageNumber === 1 ? undefined : newPageNumber
            });
        });
        history.push({
            pathname: location.pathname,
            search: queryString
        });
    };
    var clearOneIndexedPageNumber = function() {
        setOneIndexedPageNumber(function() {
            return 1;
        });
    };
    return {
        filterKeys: uniqueSortedFilterKeys,
        setFilterKeys: setFilterKeys,
        clearFilters: clearFilters,
        oneIndexedPageNumber: oneIndexedPageNumber,
        setOneIndexedPageNumber: setOneIndexedPageNumber,
        clearOneIndexedPageNumber: clearOneIndexedPageNumber
    };
};
var useUpdateQueryParamsAndStringify = function(queryParams) {
    var queryParamsInMemory = useRef(queryParams);
    useEffect(function() {
        queryParamsInMemory.current = queryParams;
    }, [
        queryParams
    ]);
    return function(updater) {
        queryParamsInMemory.current = updater(queryParamsInMemory.current);
        return qs.stringify(queryParamsInMemory.current);
    };
};
